import styled from "styled-components";

export default styled.div`
  display: inline-block;
  ${props => props.isEndPicker && "margin-left: 1px;"};
`;
